export const alias = "alias.json";
export const assetsInfo = "assets-info.json";
export const characterData = "character-data.json";
export const characters = "characters.json";
export const chartData = "chart-data.json";
export const chartExpress = "chart-express.json";
/**
 * @deprecated
 */
export const itemsData = "item-data.json";
export const items = "items.json";
export const meta = "meta.json";
export const notesAndConstants = "notes-and-constants.json";
export const packList = "packlist.json";
export const songList = "songlist.json";
export const worldMapsEvents = "world-maps-events.json";
export const worldMapsLongterm = "world-maps-longterm.json";
